var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/note"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/note_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 16.25V26C28 29 26.21 30 24 30H16C13.79 30 12 29 12 26V16.25C12 13 13.79 12.25 16 12.25C16 12.87 16.25 13.43 16.66 13.84C17.07 14.25 17.63 14.5 18.25 14.5H21.75C22.99 14.5 24 13.49 24 12.25C26.21 12.25 28 13 28 16.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 12.25C24 13.49 22.99 14.5 21.75 14.5H18.25C17.63 14.5 17.07 14.25 16.66 13.84C16.25 13.43 16 12.87 16 12.25C16 11.01 17.01 10 18.25 10H21.75C22.37 10 22.93 10.25 23.34 10.66C23.75 11.07 24 11.63 24 12.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 21H20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 25H24",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessProfile);
export default __webpack_public_path__ + "static/media/business_profile.8338686eb53cf981fb40ce8cd2d241be.svg";
export { ForwardRef as ReactComponent };